import { gql } from "@apollo/client";

export const DELETE_CASE_SCHEDULE_MUTATION = gql`
  mutation DeleteCaseScheduleMutation($caseScheduleId: String!) {
    deleteCaseSchedule(caseScheduleId: $caseScheduleId)
  }
`;
